/**
 * Given 1, 2, 3 as data;
 * DESCending order: 3, 2, 1
 * ASCending order: 1, 2, 3
 *
 * Given a, b, c as data;
 * DESCending order: c, b, a
 * ASCending order: a, b, c
 */
export function directionResult(
  direction: 'ASC' | 'DESC' | undefined,
): 'up' | 'down' | undefined {
  if (direction === 'ASC') {
    return 'up';
  }
  if (direction === 'DESC') {
    return 'down';
  }

  return undefined;
}
